<template>
  <div class="l-footer">
    <!-- 经营许可证编号：京B2-20192753 京公⽹安备 11010802027506号 (京ICP备18042108号-1) <a href="http://beian.miit.gov.cn" target="blank">http://beian.miit.gov.cn</a><br>
    Powered by 北京励⽴⻓平教育科技有限公司 ©1997-2021 <a href="https://www.lilyclass.com" target="blank">www.lilyclass.com</a> Beijing lili changfu network technology co. LTD<br>
    ⽹上有害信息举报 举报邮箱：cs@lilyenglish.com 举报电话：4000581997 -->
    Copyright © 2021 大愿科技 网站备案：琼ICP备2021007209号-1 琼B2-20210969号 客服：service@dayuan1997.com
  </div>
</template>

<script>
export default {}
</script>

<style lang="stylus" scoped>
@import './index.styl';
</style>
